import React from 'react';
import { T } from '../../../../../../common/locale/translate';

export default class OfferFigure extends React.Component {
  render() {
    const { special_offer, offerType } = this.props;
    const thumbnail = special_offer.subject.image_url
      ? special_offer.subject.image_url
      : special_offer.subject.thumbnail_url
        ? special_offer.subject.image_urls[0]
        : '/img/placeholder/offer-250x240.png';

    return (
      <figure className="b-lazy">
        <img src={thumbnail} alt="img" />
        <div className="offer-categories">
          {special_offer.is_allinclusive && (
            <span className="offer-category all-inclusive">
              {T('all_inclusive')}
            </span>
          )}
          {special_offer.is_firstminute && (
            <span className="offer-category first-minute">
              {T('first_minute')}
            </span>
          )}
          {special_offer.is_lastminute && (
            <span className="offer-category last-minute">
              {T('last_minute')}
            </span>
          )}
          <span className={`offer-category ${special_offer.offer_type}`}>
            {offerType}
          </span>
        </div>
      </figure>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/offer_figure.jsx